/* src/app/pages/ui-kit/components/uploadfile-view/uploadfile-view.component.scss */
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.box {
  display: block;
}
.box h3 {
  font-size: 1.375rem;
  color: var(--text-color-secondary);
  font-weight: 600;
}
/*# sourceMappingURL=uploadfile-view.component.css.map */
